/**
 * Bcx Currency pipe
 * Transforms Bcx currency object (i.e. { unit,value,type }) into render value (i.e. $25.00)
 *
 * @version
 * 4.36.0 OAUI-510 Add / Edit / Remove Attachments
 * 4.35.0 OAUI-500 View order adjustments
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2022 Build Centrix
 */
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'BcxCurrency',
})
export class BcxCurrencyPipe implements PipeTransform {
  /**
   * Format Money
   * @since 4.35.0
   */
  static formatMoney(n: number) {
    return n.toFixed(2).replace(/./g, (c, i, a) => {
      return i && c !== '.' && (a.length - i) % 3 === 0 ? ',' + c : c;
    });
  }

  /**
   * Parse Unit as Symbol
   * @since 4.35.0
   */
  static parse(unit: string) {
    let result;

    switch (unit.toLowerCase()) {
      case 'cad':
        result = '$';
        break;
      case 'usd':
        result = '$';
        break;
      case 'gbp':
        result = '£';
        break;
      case 'eur':
        result = '€';
        break;
      case 'dollar':
        result = '$';
        break;
      case 'pound':
        result = '£';
        break;
      case 'euro':
        result = '€';
        break;
      default:
        result = '';
    }

    return result;
  }

  /**
   * Remove Characters
   * @since 4.35.0
   */
  static removeCharacters(n: string) {
    return parseFloat(n.toString().replace(/[^0-9/.]/g, ''));
  }

  /**
   * Pipe Transform
   * @since 4.35.0
   */
  transform(obj: any): string {
    let result = '';
    const symbolPrefix = obj.unit ? BcxCurrencyPipe.parse(obj.unit) : '';
    const valueNoChars = BcxCurrencyPipe.removeCharacters(obj.value);

    // Negative Result
    if (obj.value < 0) {
      result = '-' + symbolPrefix + BcxCurrencyPipe.formatMoney(valueNoChars);
    }

    // Zero or Positive Result
    if (obj.value > 0 || obj.value === 0) {
      result = symbolPrefix + BcxCurrencyPipe.formatMoney(valueNoChars);
    }

    return result;
  }
}
